// Store карты площадки.
//
// Карта Яндекса грузится ЛЕНИВО: <script> JS API v3 инжектится в <head>
// только при первом вызове show() (клик по адресу). Промис загрузки —
// модульный синглтон, поэтому повторные клики и несколько триггеров
// переиспользуют одну загрузку и не плодят запросы.
//
// ВАЖНО: инстанс карты ymaps3 и её центр держим в МОДУЛЬНЫХ переменных,
// а не в реактивном состоянии Alpine. Если положить инстанс в стор, Alpine
// обернёт его в Proxy, и обращения к внутренностям ymaps3 (addChild и т.п.)
// бросают исключение — карта при этом успевает отрисоваться, но мы ловим
// ошибку и показываем плашку. Поэтому в сторе — только примитивы состояния.

let apiPromise  = null;
let mapInstance = null;
let mapCenter   = null; // [lng, lat] для ymaps3

function loadApi() {
    if (apiPromise) {
        return apiPromise;
    }

    const apiUrl = window.yep_maps?.api_url;

    if (!apiUrl) {
        return Promise.reject(new Error('yep_maps.api_url не задан.'));
    }

    apiPromise = new Promise((resolve, reject) => {
        const fail = (err) => {
            apiPromise = null; // позволяем повторить попытку загрузки
            reject(err);
        };

        const script = document.createElement('script');
        script.src   = apiUrl;
        script.async = true;
        script.onload = () => {
            if (!window.ymaps3 || !window.ymaps3.ready) {
                fail(new Error('ymaps3 недоступен после загрузки скрипта.'));
                return;
            }
            // ymaps3.ready резолвится, когда API полностью готов к работе.
            window.ymaps3.ready.then(() => resolve(window.ymaps3), fail);
        };
        script.onerror = () => fail(new Error('Не удалось загрузить API Яндекс.Карт.'));
        document.head.appendChild(script);
    });

    return apiPromise;
}

function renderMap(ymaps3) {
    const container = document.getElementById('venue-map');

    if (!container) {
        throw new Error('Контейнер карты #venue-map не найден.');
    }

    const {YMap, YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer, YMapMarker} = ymaps3;

    // Пересоздаём карту при каждом открытии — у ymaps3 нет простого
    // «переехать на новый центр + сменить контейнер», а площадок мало.
    if (mapInstance) {
        mapInstance.destroy();
        mapInstance = null;
    }
    container.innerHTML = '';

    // Тема карты подстраивается под текущую тему сайта (класс `dark` на <html>).
    const isDark = document.documentElement.classList.contains('dark');

    mapInstance = new YMap(container, {
        location: {center: mapCenter, zoom: 16},
        theme: isDark ? 'dark' : 'light',
    });

    mapInstance.addChild(new YMapDefaultSchemeLayer());
    mapInstance.addChild(new YMapDefaultFeaturesLayer());

    const markerEl = document.createElement('div');
    markerEl.className = 'venue-map-marker';
    mapInstance.addChild(new YMapMarker({coordinates: mapCenter}, markerEl));
}

export const mapStore = (Alpine) => Alpine.store('map', {

    open: false,
    loading: false,
    error: false,

    name: '',
    address: '',

    isEnabled() {
        return !!window.yep_maps?.enabled;
    },

    // payload: { lat, lng, name, address }
    show(payload) {
        if (!this.isEnabled()) {
            return;
        }

        const lat = parseFloat(payload?.lat);
        const lng = parseFloat(payload?.lng);

        if (Number.isNaN(lat) || Number.isNaN(lng)) {
            console.error('Некорректные координаты площадки:', payload);
            return;
        }

        mapCenter    = [lng, lat]; // ymaps3 ожидает [долгота, широта]
        this.name    = payload?.name || '';
        this.address = payload?.address || '';
        this.error   = false;
        this.loading = true;
        this.open    = true;

        // Блокируем скролл страницы под оверлеем
        document.documentElement.classList.add('overflow-hidden');

        loadApi()
            .then((ymaps3) => {
                // Контейнер появляется в DOM только при open=true (x-show),
                // ждём следующий тик Alpine, чтобы он отрисовался.
                return Alpine.nextTick().then(() => {
                    renderMap(ymaps3);
                    this.loading = false;
                });
            })
            .catch((err) => {
                console.error(err);
                this.error   = true;
                this.loading = false;
            });
    },

    close() {
        this.open = false;
        document.documentElement.classList.remove('overflow-hidden');

        if (mapInstance) {
            mapInstance.destroy();
            mapInstance = null;
        }
    },

});